export const REFRESH_DATE_KEY = 'influencerRefreshDate';
export const REFRESH_COUNT_KEY = 'influencerRefreshCount';
export const MAX_REFRESHES_PER_DAY = 10;

/**
 * Number of influencers to process per edge-function call.
 *
 * Each handle triggers ~3 sequential operations in the validate-influencer-handles
 * edge function (profile fetch, image upload, media fetch) at ~2-4s each.
 * With BATCH_SIZE=5 the worst-case wall-clock time per batch is ~60s, which
 * fits comfortably inside the Supabase Edge Function timeout.
 */
export const BATCH_SIZE = 5;

/**
 * Delay in milliseconds between consecutive batch calls to avoid
 * hitting HikerAPI rate limits. Each batch triggers multiple
 * sequential API calls inside the edge function.
 */
export const BATCH_DELAY_MS = 2000;
